import React from "react";
import "./style.css";

export default function SpinnerL2({ size = 56 }) {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return <div className="spinner_l3" style={spinnerStyle}></div>;
}
